import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AuthModule } from "./auth/auth.module";
import { TasksModule } from "./tasks/tasks.module";
import { PartnersModule } from "./partners/partners.module";
import { EnumerationModule } from "./enumeration/enumeration.module";
import { TasksFileModule } from "./taks-file/tasks-file.module";
import { PartnerUsersModule } from "./partner-users/partners.module";
import { TasksInternalPartnerFileModule } from "./taks-internal-partner-file/tasks-internal-partner-file.module";

@NgModule({
  imports: [CommonModule],
  exports: [
    AuthModule,
    PartnersModule,
    PartnerUsersModule,
    EnumerationModule,
    TasksModule,
    TasksFileModule,
    TasksInternalPartnerFileModule,
  ],
})
export class GraphqlModule {}
